import React, { useState } from 'react';
import styles from './editPipelineModal.module.scss';
import { Col, Modal, Button, Row, Badge, Card, Form } from 'react-bootstrap';
import { CustomDropdown } from '../../../../shared/customDropdown';
import { CustomTextArea } from '../../../../shared/customTextArea';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomDraggbleTextField } from '../../../../shared/customDraggbleTextField';
import { CustomButton } from '../../../../shared/customButton';
import { CustomSecondaryCheckBox } from '../../../../shared/customSecondaryCheckBox';
import { CustomStarTextField } from '../../../../shared/customStarTextField';
import { updatePipeline } from '../../../../../services/util/hiringpipeline';


import * as yup from 'yup';
import { Formik, FieldArray } from 'formik';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { CustomTextEditor } from '../../../../shared/customTextEditor';
var currencyCodes = require('currency-codes');

export const EditPipelineModal = (props) => {
    let [pipelineData, setPipelineData] = useState(props.editPipelineObj);
    let [isLoading, setLoading] = useState(false);

    let [description_body_html, setDescriptionBodyHtml] = useState(pipelineData.jobDescription);
    let contentState = '';
    const
        dropValue = [
            {
                label: 'Full-Time',
                value: 10,
            },
            {
                label: 'Part-Time',
                value: 20,
            },
            {
                label: 'Contract/ Temp',
                value: 30,
            },
            {
                label: 'Casual/ Vacation',
                value: 40,
            },
            {
                label: 'Internship',
                value: 50,
            },
        ]
    const
        dropValueMobility = [
            {
                label: 'Remote',
                value: 10,
            },
            {
                label: 'On-Site',
                value: 20,
            },
            {
                label: 'Hybrid',
                value: 30,
            },
        ]
    const
        dropValueSalary = [
            {
                label: 'Hourly',
                value: 10,
            },
            {
                label: 'Daily',
                value: 20,
            },
            {
                label: 'Weekly',
                value: 30,
            },
            {
                label: 'Fortnight',
                value: 40,
            },
            {
                label: 'Monthly',
                value: 50,
            },
        ]

    let currencyCodeDropdownArray = []
    let currencyCodeArray = currencyCodes.codes()

    for (let index = 0; index < currencyCodeArray.length; index++) {
        let currency_code_object = {
            label: currencyCodeArray[index],
            value: currencyCodeArray[index]
        }

        currencyCodeDropdownArray.push(currency_code_object)
    }

    //yup validations
    yup.addMethod(yup.array, 'unique', function (message, mapper = a => a) {
        return this.test('unique', message, function (list) {
            return list.length === new Set(list.map(mapper)).size;
        });
    })

    const schema = yup.object({
        pipelineName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').required('Required'),
        position: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').required('Required'),
        vacancyDesc: yup.string()
            .required('Required')
            .test('email body check', 'Required', function (item) {
                let strippedHtml = item.replace(/<[^>]+>/g, '');
                return strippedHtml.trim().length > 0;
            })
            .required('Required'),
        jobMobility: yup.number().required('Required'),
        jobType: yup.number().required('Required'),
        paidCurrency: yup.string().required('Required'),
        salaryPaidBy: yup.number().required('Required'),
        location: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').nullable(true),
        customQuestions: yup.array().of(
            yup.object().shape({
                question: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required')
            })
        ),
    });

    //on submit function
    const onSubmit = async (values) => {
        setLoading(true);
        let respond = await updatePipeline(pipelineData.pipelineID, values.pipelineName, values.position, values.vacancyDesc, values.jobType, values.jobMobility, values.paidCurrency, values.location, values.coverLetter, values.salaryExpectation, values.availableDate, values.customQuestions, values.salaryPaidBy);
        if (respond.success === true) {
            setLoading(false);
            props.getPipelineValues();
            props.handleClose();
        } else {
            setLoading(false);
        }
    }

    const addAdditionalQuestion = (e, values, setValues) => {

        const customQuestions = [...values.customQuestions];

        let newCustomQuestion = {
            question: ''
        }

        customQuestions.push(newCustomQuestion);
        setValues({ ...values, customQuestions });

    }

    const removeAddiionalQuestion = (e, id, values, setValues) => {
        const customQuestions = [...values.customQuestions];
        if (customQuestions.length !== 0) {
            let newArray = customQuestions.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, customQuestions: newArray });
        }
    }

    const msgSvg = (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="message-text-circle-02">
                <path id="Icon" d="M5.33333 6.83333H8M5.33333 9.16667H10M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 9.2981 2.15582 10.0598 2.43871 10.7563C2.49285 10.8897 2.51992 10.9563 2.532 11.0102C2.54381 11.0629 2.54813 11.1019 2.54814 11.1559C2.54814 11.2111 2.53812 11.2713 2.51807 11.3916L2.12275 13.7635C2.08135 14.0119 2.06065 14.1361 2.09917 14.2259C2.13289 14.3045 2.19552 14.3671 2.27412 14.4008C2.36393 14.4393 2.48812 14.4186 2.73651 14.3772L5.10843 13.9819C5.22872 13.9619 5.28887 13.9519 5.34409 13.9519C5.3981 13.9519 5.43711 13.9562 5.48981 13.968C5.54369 13.9801 5.61035 14.0072 5.74366 14.0613C6.4402 14.3442 7.2019 14.5 8 14.5Z" stroke="" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>
    )

    const salarySvg = (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="bank-note-01">
                <path id="Icon" d="M3.99998 7.83334V10.5M12 6.5V9.16667M11.3333 3.16667C12.9658 3.16667 13.8487 3.41651 14.2881 3.6103C14.3466 3.63611 14.3758 3.64901 14.4602 3.72959C14.5109 3.77788 14.6032 3.9196 14.627 3.9854C14.6666 4.09516 14.6666 4.15516 14.6666 4.27517V11.4408C14.6666 12.0466 14.6666 12.3495 14.5758 12.5052C14.4834 12.6636 14.3943 12.7373 14.2213 12.7981C14.0512 12.858 13.708 12.792 13.0214 12.6601C12.5409 12.5678 11.971 12.5 11.3333 12.5C9.33331 12.5 7.33331 13.8333 4.66665 13.8333C3.03417 13.8333 2.15122 13.5835 1.7119 13.3897C1.6534 13.3639 1.62414 13.351 1.53971 13.2704C1.4891 13.2221 1.39672 13.0804 1.37296 13.0146C1.33331 12.9048 1.33331 12.8448 1.33331 12.7248L1.33331 5.55924C1.33331 4.9534 1.33331 4.65047 1.42416 4.49477C1.51658 4.33638 1.60571 4.26275 1.77869 4.20188C1.94874 4.14204 2.292 4.20799 2.97853 4.3399C3.45906 4.43223 4.02897 4.5 4.66665 4.5C6.66665 4.5 8.66665 3.16667 11.3333 3.16667ZM9.66665 8.5C9.66665 9.42048 8.92045 10.1667 7.99998 10.1667C7.07951 10.1667 6.33331 9.42048 6.33331 8.5C6.33331 7.57953 7.07951 6.83334 7.99998 6.83334C8.92045 6.83334 9.66665 7.57953 9.66665 8.5Z" stroke="" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>
    )

    const availableDateSvg = (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="calendar-check-01">
                <path id="Icon" d="M14 7.16666H2M10.6667 1.83333V4.49999M5.33333 1.83333V4.49999M6 11.1667L7.33333 12.5L10.3333 9.5M5.2 15.1667H10.8C11.9201 15.1667 12.4802 15.1667 12.908 14.9487C13.2843 14.7569 13.5903 14.451 13.782 14.0746C14 13.6468 14 13.0868 14 11.9667V6.36666C14 5.24656 14 4.6865 13.782 4.25868C13.5903 3.88236 13.2843 3.5764 12.908 3.38465C12.4802 3.16666 11.9201 3.16666 10.8 3.16666H5.2C4.0799 3.16666 3.51984 3.16666 3.09202 3.38465C2.71569 3.5764 2.40973 3.88236 2.21799 4.25868C2 4.6865 2 5.24656 2 6.36666V11.9667C2 13.0868 2 13.6468 2.21799 14.0746C2.40973 14.451 2.71569 14.7569 3.09202 14.9487C3.51984 15.1667 4.0799 15.1667 5.2 15.1667Z" stroke="" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>

    )
    const removeTextDecoration = (htmlContent) => {
        let noDecoration = htmlContent.replace(/<span style="text-decoration: (underline|line-through|overline);[^>]*>(.*?)<\/span>/gi, '$2');
        noDecoration = noDecoration.replace(/<span style="background-color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        noDecoration = noDecoration.replace(/<span style="color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        let withFont = noDecoration.replace(/(<span[^>]*>)(<\/span>)/gi, (match, opening, closing) => {
            if (opening) {
                return opening + ' style="font-family: Inter, sans-serif; font-size: 12px;"' + closing;
            } else {
                return closing;
            }
        });
    
        // Set font family and size to Inter, sans-serif; font-size: 16px for all heading tags
        const headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        headings.forEach(tag => {
            const regex = new RegExp(`<${tag}[^>]*>(.*?)</${tag}>`, 'gi');
            withFont = withFont.replace(regex, (match, content) => {
                return `<h3 style="font-family: Inter, sans-serif; font-size: 16px !important;">${content}</h3>`;
            });
        });
    
        return withFont;
    };
    
    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Edit Vacancy Details</h2>
                    </div>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <div>
                            <Formik
                                validationSchema={schema}
                                onSubmit={(values) => onSubmit(values)}
                                initialValues={{ pipelineName: pipelineData.pipelineName, position: pipelineData.position, vacancyDesc: pipelineData.jobDescription,jobType: pipelineData.job_type, jobMobility: pipelineData.job_mobility, paidCurrency: pipelineData.paid_currency, location: pipelineData.location, coverLetter: pipelineData.cover_letter, salaryExpectation: pipelineData.salary_expectation, availableDate: pipelineData.available_date, customQuestions: pipelineData.custom_questions, salaryPaidBy: pipelineData.salary_paid_by, reviewCriteriaToBeAdded: ''}}>

                                {({
                                    values,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    submitCount,
                                    touched,
                                    setValues,
                                    setFieldValue
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <CustomTextField
                                            label="Pipeline Name"
                                            classLabel="defaultLabel"
                                            controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_pipelineNameFieldId"
                                            placeholder="Ex: Software Engineers Pipeline"
                                            type="text"
                                            value={values.pipelineName}
                                            name="pipelineName"
                                            classType="defaultTextBox"
                                            maxlength={60}
                                            handleOnChange={handleChange}
                                            errorMessage={errors.pipelineName}
                                            isInvalid={submitCount > 0 && !!errors.pipelineName}
                                        />
                                        <Row>

                                            <Col>
                                                <CustomTextField
                                                    label="Position"
                                                    classLabel="defaultLabel"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_positionFieldId"
                                                    placeholder="Ex: Software Engineer"
                                                    type="text"
                                                    value={values.position}
                                                    name="position"
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    errorMessage={errors.position}
                                                    isInvalid={submitCount > 0 && !!errors.position}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='pb-2'>
                                                <Form.Label className={styles.defaultLabel}>
                                                    Job Description
                                                </Form.Label>
                                                <div className={submitCount > 0 && errors.vacancyDesc ? styles.descriptionBodyError : ''}>
                                                    <CustomTextEditor
                                                    value = {description_body_html}
                                                    handleOnChange={(e) => {
                                                        setDescriptionBodyHtml(e);
                                                        setFieldValue('vacancyDesc', removeTextDecoration(e));
                                                    }}
                                                    />
                                                </div>
                                                {submitCount > 0 && errors.vacancyDesc &&
                                                <p className={styles.errorLabel} id="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_vacancyDescFieldId">{errors.vacancyDesc}</p>
                                            }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <CustomDropdown
                                                    label="Job Type"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_jobTypeDropDownId"
                                                    name="jobType"
                                                    value={values.jobType}
                                                    handleOnChange={(e) => { setFieldValue('jobType', parseInt(e.target.value)); }}
                                                    dropdownValues={dropValue}
                                                    errorMessage={errors.jobType}
                                                    isInvalid={submitCount > 0 && !!errors.jobType}
                                                    hiddenOption="Select Job Type"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <CustomDropdown
                                                    label="Work Type"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_workTypeDropDownId"
                                                    name="jobMobility"
                                                    value={values.jobMobility}
                                                    handleOnChange={(e) => {
                                                        setFieldValue('jobMobility', parseInt(e.target.value));
                                                        // changeType(e.target.value)
                                                    }}
                                                    dropdownValues={dropValueMobility}
                                                    errorMessage={errors.jobMobility}
                                                    isInvalid={submitCount > 0 && !!errors.jobMobility}
                                                    hiddenOption="Select Work Type"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>

                                            <Col>
                                                <CustomTextField
                                                    label="Location"
                                                    classLabel="defaultLabel"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_locationFieldId"
                                                    placeholder="ex:- Colombo, Sri Lanka"
                                                    type="text"
                                                    value={values.location}
                                                    name="location"
                                                    classType="defaultTextBox"
                                                    handleOnChange={handleChange}
                                                    maxlength={60}
                                                    errorMessage={errors.location}
                                                    isInvalid={submitCount > 0 && !!errors.location}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6} >
                                                <CustomDropdown
                                                    label="Paid Currency"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_paidCurrencyDropDownId"
                                                    name="paidCurrency"
                                                    value={values.paidCurrency}
                                                    handleOnChange={(e) => {
                                                        setFieldValue('paidCurrency', e.target.value);
                                                        // changeType(e.target.value)
                                                    }}
                                                    dropdownValues={currencyCodeDropdownArray}
                                                    errorMessage={errors.paidCurrency}
                                                    isInvalid={submitCount > 0 && !!errors.paidCurrency}
                                                    hiddenOption="Select Currency"
                                                />
                                            </Col>
                                            <Col sm={6}>
                                                <CustomDropdown
                                                    label="Salary Paid By"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_salaryPaidByDropDownId"
                                                    name="salaryPaidBy"
                                                    value={values.salaryPaidBy}
                                                    handleOnChange={(e) => {
                                                        setFieldValue('salaryPaidBy', parseInt(e.target.value));
                                                        // changeType(e.target.value)
                                                    }}
                                                    dropdownValues={dropValueSalary}
                                                    errorMessage={errors.salaryPaidBy}
                                                    isInvalid={submitCount > 0 && !!errors.salaryPaidBy}
                                                    hiddenOption="Select Salary paid by"
                                                />
                                            </Col>
                                        </Row>
                                        <div className={styles.responsibilitiesDiv}>
                                            <p className={styles.subTopics}>Required Additional Details From Candidates</p>
                                            <Row>

                                                <Col cm={12}>
                                                    <CustomSecondaryCheckBox
                                                        svg={msgSvg} // Pass the SVG code as a prop
                                                        id="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_coverLetterCheckboxId"
                                                        label="Cover Letter"
                                                        controlId="coverLetter"
                                                        name="coverLetter"
                                                        handleOnChange={() => { setFieldValue(`coverLetter`, !values.coverLetter); }}
                                                        type="defaultCheckBox"
                                                        value={values.coverLetter}
                                                        ischecked={values.coverLetter}

                                                    />

                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col cm={12}>
                                                    <CustomSecondaryCheckBox
                                                        svg={salarySvg} // Pass the SVG code as a prop
                                                        id="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_salaryExpectationCheckboxId"
                                                        label="Salary Expectation"
                                                        controlId="salaryExpectation"
                                                        name="salaryExpectation"
                                                        handleOnChange={() => { setFieldValue(`salaryExpectation`, !values.salaryExpectation); }}
                                                        type="defaultCheckBox"
                                                        value={values.salaryExpectation}
                                                        ischecked={values.salaryExpectation}

                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col cm={12}>
                                                    <CustomSecondaryCheckBox
                                                        svg={availableDateSvg} // Pass the SVG code as a prop
                                                        id="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_availableDateCheckboxId"
                                                        label="Available Date"
                                                        controlId="availableDate"
                                                        name="availableDate"
                                                        handleOnChange={() => { setFieldValue(`availableDate`, !values.availableDate); }}
                                                        type="defaultCheckBox"
                                                        value={values.availableDate}
                                                        ischecked={values.availableDate}

                                                    />
                                                </Col>
                                            </Row>
                                        </div>


                                        <div className={styles.responsibilitiesDiv}>
                                            <p className={styles.subTopics}>Custom Questions</p>
                                            <FieldArray name="customQuestions">
                                                {(arrayHelpers) => {
                                                    const handleOnDragEnd = (result) => {
                                                        if (!result.destination) {
                                                            return;
                                                        }

                                                        const { source, destination } = result;

                                                        arrayHelpers.move(source.index, destination.index);
                                                    };

                                                    return (
                                                        <DragDropContext onDragEnd={handleOnDragEnd}>
                                                            <Droppable droppableId="customQuestions">
                                                                {(provided) => (
                                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                                        <>
                                                                            {values.customQuestions && values.customQuestions.map((question, i) => {
                                                                                const customQuestionErrors = (errors.customQuestions?.length && errors.customQuestions[i]) || {};
                                                                                const customQuestionTouched = (touched.customQuestions?.length && touched.customQuestions[i]) || {};
                                                                                return (
                                                                                    <Draggable key={i} draggableId={`customQuestion-${i}`} index={i}>
                                                                                        {(provided) => (
                                                                                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                                <CustomDraggbleTextField
                                                                                                    keyValue={i}
                                                                                                    classLabel="defaultLabel"
                                                                                                    controlId={`adminPanel_hiringPipeline_editPipeline_EditPipelineModal_customQuestionsFieldId.${i}`}
                                                                                                    type="text"
                                                                                                    value={(values && values.customQuestions && values.customQuestions[i]) && values.customQuestions[i].question}
                                                                                                    handleOnChange={handleChange}
                                                                                                    name={`customQuestions.${i}.question`}
                                                                                                    classType="defaultTextBox"
                                                                                                    onCancelClick={(e) => removeAddiionalQuestion(e, i, values, setValues)}
                                                                                                    errorMessage={(errors && errors.customQuestions && errors.customQuestions[i]) && errors.customQuestions[i].question}
                                                                                                    isInvalid={!!(customQuestionErrors.question && customQuestionTouched.question)}
                                                                                                    isCancelable={true}
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                );
                                                                            })}
                                                                            {provided.placeholder}
                                                                        </>
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>
                                                    );
                                                }}
                                            </FieldArray>
                                            <CustomButton
                                                buttonType="button"
                                                label="Add Custom Question"
                                                type="secondarySmallBtn"
                                                handleClick={(e) => addAdditionalQuestion(e, values, setValues)}
                                                frontIcon={
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                        <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                            />



                                        </div>
                                        <Row className="mr-2 d-flex flex-row-reverse">
                                            <div className={styles.actionBtns}>
                                                {<CustomButton
                                                    buttonType="edit_vacancy_details_submit"
                                                    label="Save"
                                                    id="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_saveBtnId"
                                                    type="primaryBtn"
                                                    disabled={isLoading === true ? true : false}
                                                    backicon={
                                                        isLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                            : ''
                                                    }

                                                />}
                                            </div>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>


                        </div>
                    </Col>

                </Modal.Body>
            </Modal>
        </div>
    )
}
